import { render, staticRenderFns } from "./ReplacementRuleForm.vue?vue&type=template&id=03dafdf1"
import script from "./ReplacementRuleForm.vue?vue&type=script&lang=js"
export * from "./ReplacementRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports